import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import moment from "moment";
import PaginationComponent from "../../../components/comman/PaginationComponent";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import { formatAmount } from "../../../utility/CommonFunctions";
import { Spinner } from "reactstrap";
import MainHeading from "../../../components/comman/MainHeading";

export default function TdsDetail() {
  let { id } = useParams();
  const userDetails = useSelector((state) => state.root.userDetails);
  const location = useLocation();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    sortByDate: [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
    year: "",
    CustomerLedgerData: [],
    countsData: {},
    companyList: [],
    companyId: "",
    siteId: "",
    siteList: []
  });

  useEffect(() => {
    if (pageStates?.year) {
      GetCustomerLedgerData();
    }
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    pageStates?.sortByDate,
    pageStates?.year,
    pageStates?.companyId,
    pageStates?.siteId
  ]);

  useEffect(() => {
    GetCompanyList();
    GetSiteList();
  }, []);

  const GetSiteList = (companyId = null) => {
    let options = {
      method: "GET",
    };
    let API =
      userDetails?.type === 2
        ? apiUrl.get_site + `?type=site&pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}`
        : apiUrl.get_user_site + `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          siteList: response?.data?.site,
        }));
      }
    });
  };

  const GetCustomerLedgerData = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_transaction +
      `?from=customer&customerId=${id}&` +
      MainFilterHandler(pageStates);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          CustomerLedgerData: res?.data?.transaction,
          countsData: { ...res?.data?.counts },
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const GetCompanyList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_company + `?pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          companyList: response?.data?.company,
        }));
      }
    });
  };


  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        name: "",
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };


  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList
  };

  const handleSortData = (data, type) => {
    setPageStates((pre) => ({
      ...pre,
      ...(type === "site" && { siteId: data?.site }),
      // ...(type && { officeType: data?.office }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    if (type == "companyId") {
      GetSiteList(data?.companyId);
    }
  };

  const handleYearChange = (selectedYear) => {
    setPageStates((prev) => ({
      ...prev,
      year: selectedYear,
      sortByDate: isFirstYearChange ? prev.sortByDate : [],
    }));

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };



  return (
    <>
      <div className="content container-fluid">
        <MainHeading
          showBackButton={true}
          title={"TDS Detail"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
          handleYearChange={handleYearChange}
        />
        <div className="card mb-4">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h2 className="card-title d-flex align-items-center gap-3">
                <span className="d-flex align-items-center justify-content-center p-3 rounded-circle bg-white border border-dark">
                  <svg
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    viewBox="0 0 466.415 466.415"
                    className=""
                  >
                    <g>
                      <path
                        d="M464.8 309.008c-3.1-4.6-9.2-5.8-13.8-2.7l-74.6 48.9h-98.2v-41h101.2c2.1 0 4.2-.8 5.8-2l77-55.6c4.5-3.2 5.5-9.5 2.2-13.9-3.2-4.5-9.5-5.5-13.9-2.2l-74.3 53.7h-98v-42h101.2c2.2.1 4.4-.6 6.2-1.9l77-60.7c4.3-3.5 5-9.8 1.6-14.1s-9.6-5-14-1.7l-74.3 58.4h-97.7v-40h101.2c2.5-.1 5-1.1 6.8-2.8l77-71.4c3-2.9 4-7.3 2.5-11.2-1.5-3.9-5.2-6.5-9.3-6.6H361c-.1 0-.3-1.8-.6-2.6-1.5-3.8-5.2-6.4-9.3-6.4h-153c-2.5 0-5 1-6.8 2.7l-6.7 6.3H87c-2.5.1-5 1.1-6.8 2.9l-77 71.3c-3 2.9-4 7.3-2.5 11.2 1.5 3.9 5.2 6.5 9.3 6.6h95.2v40H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v42H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v41H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h369.4c2-.1 3.9-.7 5.5-1.9l77-50.4c4.6-3 5.9-9.3 2.9-13.9zm-118.9-188.8h85l-55.4 52h-85.1l55.1-51.6c.1 0 .2-.4.4-.4zm-237.9 52H35.5l55.4-52h72.2l-54.6 51.2c-.2.1-.3-.2-.5.8zm150.2 6.5v176.5h-133v-172.1l68.5-63.9 8.3-8h123.7l-64.3 59.9c-2.1 2-3.2 4.7-3.2 7.6z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                      <path
                        d="M233.8 231.308h-13.5c-1.1-5-3.1-9.7-5.8-14h19.3c5.6-.1 10.1-4.6 10.1-10.1s-4.5-10-10-10h-78.4c-5.5 0-10 4.5-10 10s4.5 10 10 10H178c9.5 0 17.6 5 21.4 14h-43.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h43.9c-1.3 2.3-2.9 4.5-4.7 6.4-4.5 4.4-10.5 6.7-16.8 6.6h-22.5c-5.6.1-10.1 4.6-10 10.2 0 2.7 1.2 5.3 3.1 7.2l56.1 53.1c4 3.8 10.3 3.7 14.1-.3 3.8-4 3.7-10.3-.3-14.1l-.1-.1-37.9-35.8c10.6-.5 20.7-5 28.3-12.5 5.6-5.8 9.6-12.9 11.6-20.6h13.5c5.5 0 10-4.5 10-10s-4.5-10-10-10z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                    </g>
                  </svg>
                </span>
                {location?.state?.name || "Ledger Entries"}
              </h2>
              <div className="d-flex gap-3  align-items-center justify-content-between text-center">
                <p
                  className={"text-danger mb-0"}
                >
                  <span className="text-muted">Due Amount : </span>
                  {formatAmount(pageStates?.countsData?.netAmount || 0)}
                </p>
                <div className="vr"></div>
                <p
                  className={
                    pageStates?.countsData?.openingBalance === 0
                      ? "text-warning mb-0"
                      : pageStates?.countsData?.openingBalance > 0
                        ? "text-success mb-0"
                        : "text-danger mb-0"
                  }
                >
                  <span className="text-muted">Opening Balance : </span>
                  {formatAmount(pageStates?.countsData?.openingBalance || 0)}
                </p>
              </div>
            </div>
            <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h5 className="m-0">
                  {pageStates?.countsData?.totalEntries} Entries
                </h5>
              </div>
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h5 className="m-0 text-success">
                  {formatAmount(pageStates?.countsData?.creditAmount || 0)}{" "}
                </h5>
              </div>
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h5 className="m-0 text-danger">
                  {formatAmount(pageStates?.countsData?.debitAmount || 0)}
                </h5>
              </div>
            </div>

            <div className="ledgers">
              {pageStates?.tableLoader ? (
                <div className="d-flex justify-content-center my-5 ">
                  <Spinner />
                </div>
              ) : pageStates?.CustomerLedgerData &&
                pageStates?.CustomerLedgerData?.length > 0 ? (
                pageStates?.CustomerLedgerData?.slice()
                  .reverse()
                  ?.map((item, index) => (
                    <>
                      {/* //INVOICE==========> */}
                      {item?.invoice !== null && (
                        <div key={index} className="ledger">
                          <span className="icon px-2 py-2">
                            <span className="fs-5 fw-bold">{moment(item?.createdAt).date()}</span>
                            <p className="fs-6 m-0">
                              {moment(item?.createdAt).format("MMM")}
                            </p>
                          </span>
                          <div>
                            {item?.type === "due" &&
                              <p className="time text-muted mb-0">
                                Invoice Date -{" "}
                                {moment(item?.invoice?.invoiceDate).format(
                                  "DD/MM/YYYY"
                                )}
                              </p>}
                            {item?.type !== "due" &&
                              <p className="time text-muted mb-0">
                                Trans. Date -{" "}
                                {moment(item?.transactionDate).format(
                                  "DD/MM/YYYY"
                                )}
                              </p>}
                            {item?.invoice?.invoiceNumber && (
                              <p className="time  mb-0 mt-0 fw-bold">
                                {item?.type === "debitNote" ? "Debit Note No." : item?.type === "due" ? "Invoice No." : "Trans. No."} - {item?.type !== "due" ? item?.transactionId : ""} (
                                {item?.invoice?.invoiceNumber})
                              </p>
                            )}
                            <p className="time text-muted mb-0 mt-0">
                              Created By - {item?.user?.name} ({item?.user?.designation?.name} - {item?.user?.department?.name},{" "}
                              {item?.site?.name} )
                            </p>
                            {item?.type === "credit" &&
                              <>
                                <p className="time text-muted mb-0 mt-0">
                                  Payment Method - {item?.paymentMethod}
                                </p>
                                <p className="time text-muted mb-0 mt-0">
                                  {(item?.paymentMethod === "NEFT" ||
                                    item?.paymentMethod === "RTGS" ||
                                    item?.paymentMethod === "IMPS") &&
                                    `(AC. Holder Name. - ${item?.accountHolderName})  `}
                                  {item?.paymentMethod === "Cash" &&
                                    `(Reference Name. - ${item?.referenceName})  `}
                                  {item?.paymentMethod !== "Cash"
                                    ? `(UTR No. - ${item?.utr})  `
                                    : ""}
                                  {(item?.paymentMethod === "NEFT" ||
                                    item?.paymentMethod === "RTGS" ||
                                    item?.paymentMethod === "IMPS") &&
                                    `(Bank Name. - ${item?.bankName})  `}
                                  {(item?.paymentMethod === "NEFT" ||
                                    item?.paymentMethod === "RTGS" ||
                                    item?.paymentMethod === "IMPS") &&
                                    `(AC. No. - ${item?.accountNumber})  `}
                                </p>
                              </>}
                          </div>
                          <h5
                            className={
                              item?.type == "due"
                                ? "text-danger mb-0 ms-auto fw-semibold"
                                : "text-success mb-0 ms-auto fw-semibold"
                            }
                          >
                            {formatAmount(item?.amount || "--")}
                          </h5>
                          {item?.type === "debitNote" &&
                            <>
                              <p className="time text-muted m-0 text-center">
                                Remark
                              </p>
                              <p className="time text-muted m-0 remark">
                                {item?.remark || "--"}
                              </p>
                            </>}
                        </div>
                      )}
                    </>
                  ))
              ) : (
                <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                  <NoRecordIcon />
                  {"No record found"}
                </div>
              )}
            </div>

            <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
              <div className="d-flex align-items-center gap-2">
                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                  <div className="dropdown short">
                    <button
                      className="btn dropdown-toggle border"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {pageStates?.pageSize}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                            stroke="#36394A"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </span>
                    </button>
                    <ul className="dropdown-menu ">
                      {[10, 20, 30, 40, 50].map((value) => (
                        <li key={value}>
                          <button
                            className={`dropdown-item ${pageStates?.pageSize === value && "active"
                              }`}
                            onClick={() => handleChangePageSize(value)}
                          >
                            {value}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div>
                  {pageStates?.count > 0 && !pageStates?.tableLoader && (
                    <p
                      className="mb-0 text-muted fw-medium text-uppercase"
                      style={{ fontSize: "10px" }}
                    >
                      {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                        (pageStates?.pageSize - 1)
                        } to ${pageStates?.currentPage * pageStates?.pageSize <
                          pageStates?.count
                          ? pageStates?.currentPage * pageStates?.pageSize
                          : pageStates?.count
                        } of ${pageStates?.count} entries`}
                    </p>
                  )}
                </div>
              </div>

              <PaginationComponent
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                totalPages={pageStates?.totalPages}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
